import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NewsletterLandingComponent } from './components/newsletter-landing.component';

const routes: Routes = [{ path: '', component: NewsletterLandingComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewsletterLandingRoutingModule {}
